import axios, { AxiosError } from 'axios';
import type { SelfServiceAPI } from 'types';
import { SELF_SERVICE_API_URL } from 'config';
import handleServiceError from '../utils/handleServiceError';

export interface Params {
  bookingId: string;
  startDate: string;
  endDate: string;
}

interface Options {
  skipUnauthenticatedRedirection?: boolean;
  retry?: boolean;
  signal?: AbortSignal;
}

const getAvailabilityForOffer = async (
  { bookingId, startDate, endDate }: Params,
  options: Options = {},
): Promise<SelfServiceAPI.GetAvailabilityForOffer.Response> => {
  try {
    const { data } = await axios.get<SelfServiceAPI.GetAvailabilityForOffer.Response>(`${SELF_SERVICE_API_URL}/availability/${bookingId}`, {
      params: { startDate, endDate },
      withCredentials: true,
      signal: options.signal,
    });

    return data;
  } catch (error) {
    if (options.retry !== false) {
      const status = error instanceof AxiosError && error.response?.status;

      if (status === 500) {
        return await getAvailabilityForOffer({ bookingId, startDate, endDate }, { ...options, retry: false });
      }
    }

    handleServiceError(error, {
      operationName: `GET /availability/${bookingId}`,
      skipUnauthenticatedRedirection: options.skipUnauthenticatedRedirection,
    });

    return new Promise(() => {});
  }
};

export default getAvailabilityForOffer;
